<mat-form-field [appearance]="appearance!" [formGroup]="formGroup">
  <mat-datepicker-toggle matIconPrefix [for]="picker" *ngIf="dateRangeOptions?.icon == 'prefix'"></mat-datepicker-toggle>
  <mat-label>{{ label }}</mat-label>
  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate placeholder="Data inicial" formControlName="dataInicial" (blur)="onBlur()" (input)="onChange($event)">
    <input matEndDate placeholder="Data final" formControlName="dataFinal" (blur)="onBlur()" (input)="onChange($event)">
  </mat-date-range-input>
  <mat-date-range-picker #picker></mat-date-range-picker>
  <mat-datepicker-toggle matIconSuffix [for]="picker" *ngIf="dateRangeOptions?.icon == 'suffix'"></mat-datepicker-toggle>
</mat-form-field>